'use strict';

module.exports = /*@ngInject*/ ["$scope", "$uibModalInstance", "$uibModal", "$timeout", "chosenName", "templates", function ($scope, $uibModalInstance, $uibModal, $timeout, chosenName, templates) {
    $scope.error = {};

    init();

    function init() {
        $scope.newTemplateName = chosenName;
        $timeout(function () {
            isValidName($scope.newTemplateName);
            if ($scope.error.duplicate) {
                $scope.templateForm.newTemplateName.$invalid = true;
                $scope.templateForm.newTemplateName.$pristine = false;
            }
        });
    }


    $scope.close = function () {
        $uibModalInstance.dismiss();
    };

    $scope.save = function () {
        var id = 0;
        if ($scope.error.duplicate) {
            if (!confirm("Do you want to overwrite the template with name :" + $scope.newTemplateName + "?")) {
                return;
            }
            templates.forEach(function (entry) {
                if ($scope.newTemplateName == entry.name) {
                    id = entry.id;
                }
            });
        }
        var object = {};
        object.name = $scope.newTemplateName;
        object.id = id;
        $uibModalInstance.close(object);
    };

    $scope.$watch('newTemplateName', function (newValue) {
        isValidName(newValue);
    }, true);

    function isValidName(newValue) {
        if (newValue != undefined && newValue != "") {
            $scope.error.duplicate = false;
            templates.forEach(function (entry) {
                if (newValue == entry.name) {
                    $scope.error.duplicate = true;
                    $scope.templateForm.newTemplateName.$invalid = true;
                }
            });
            if (!$scope.error.duplicate) {
                $scope.templateForm.newTemplateName.$invalid = false;
            }
        }
    }
}];